import { render, staticRenderFns } from "./ShareVideo.vue?vue&type=template&id=4c509be9&scoped=true"
import script from "./ShareVideo.vue?vue&type=script&lang=js"
export * from "./ShareVideo.vue?vue&type=script&lang=js"
import style0 from "./ShareVideo.vue?vue&type=style&index=0&id=4c509be9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c509be9",
  null
  
)

export default component.exports